export const COLUMNS_HEADERS = {
  orderStatusGroupCode: { align: 'center' },
  orderCode: { align: 'center' },
  programedDateTime: { align: 'center' },
  loads: { align: 'center' },
  product: { align: 'center' },
  volume: { align: 'center' },
};
